<template>
  <Popup
    style="background: transparent"
    :value="value"
    @open="openPopup"
    @opened="openedPopup"
    :close-on-click-overlay="false"
  >
    <div class="second-confirm">
      <div class="title">{{ title }}</div>
      <div class="content">{{ content }}</div>
      <div class="second-confirm-btn-group">
        <div class="close" @click="$emit('input', false)">取消</div>
        <div
          class="confirm"
          @click="clickConfirm"
          :class="{ disabled: seconds !== 0 }"
        >
          确认 <span v-if="seconds !== 0">({{ seconds }})</span>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup } from "vant";

let IntervalId = null;
export default {
  name: "SecondConfirm",
  props: {
    value: Boolean,
    title: {
      type: String,
      default: "提示"
    },
    content: String,
    countdown: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      seconds: 0
    };
  },
  methods: {
    openPopup() {
      this.seconds = this.countdown;
      clearInterval(IntervalId);
    },
    openedPopup() {
      this.seconds = this.countdown;
      IntervalId = setInterval(() => {
        if (0 === this.seconds) {
          clearInterval(IntervalId);
          return;
        }
        this.seconds--;
      }, 1000);
    },
    clickConfirm() {
      if (0 !== this.seconds) {
        return;
      }
      this.$emit("ok");
      this.seconds = this.countdown;
      IntervalId = setInterval(() => {
        if (0 === this.seconds) {
          clearInterval(IntervalId);
          return;
        }
        this.seconds--;
      }, 1000);
    }
  },
  components: { Popup }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.second-confirm {
  width: 295px;
  background: #ffffff;
  border-radius: 3px;
  .title {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    color: #323233;
  }
  .content {
    width: 100%;
    min-height: 50px;
    padding: 6px 20px;
    color: #7d7e80;
    text-align: center;
    font-size: 14px;
  }
  .second-confirm-btn-group {
    width: 100%;
    height: 50px;
    display: flex;
    border-top: 1px solid #f7f7f7;
    div {
      text-align: center;
      line-height: 50px;
      flex: 1;
      &.confirm {
        color: #ff5858;
      }
      &.close {
        border-right: 1px solid #f7f7f7;
      }
      &.disabled {
        color: #bcbcbc;
      }
    }
  }
}
</style>
